module.exports = __webpack_public_path__ + "img/cta_5.9e743dc9.png";